import { useSearchParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import { useNavigate } from "react-router-dom";


import { useParams } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  InputAdornment
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";




import 'react-quill/dist/quill.snow.css';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Container,
  Modal,
  Tooltip,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';


const EditAnnouncement = () => {
    const { id } = useParams(); // Extract announcementId from URL
const [announcementData, setAnnouncementData] = useState(null);
const [searchParams] = useSearchParams();
const branchIdFromQuery = searchParams.get("Branch_Id");
const navigate = useNavigate();
const [isLoading, setIsLoading] = useState(true);


const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);




  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [error, setError] = useState('');
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);



  // Fetch user options
  useEffect(() => {
    const fetchUserOptions = async () => {
      
      try {
         const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


      if (!branchId) return; // ⛔ wait until branch available



        setLoadingBarProgress(30);
       const response = await fetch(`https://wsmsv1.aidigitalsec.com/api/Anouncement/GetUserGroup?Branch_Id=${branchId}`, {
       
  
       method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token'),
          },
          body: JSON.stringify({
            teacherId: sessionStorage.getItem('employeeId'),
          }),
        });
        const data = await response.json();
        const options = data.list.map((user) => ({
          value: user.userGroupId,
          label: user.userGroupname,
        }));
        setUserOptions(options);
        setLoadingBarProgress(100);
      } catch (error) {
        console.error('Error fetching user options:', error);
        setLoadingBarProgress(0);
      }
    };


    fetchUserOptions();
  }, []);


  // Fetch classes using the new API
 useEffect(() => {
  const fetchClassOptions = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


      if (!branchId) return; // ⛔ wait until branch available


      setLoadingBarProgress(30);


      const response = await fetch(
        `${apiUrl}/CreateClass/GetClassName?Branch_Id=${branchId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        }
      );


      const data = await response.json();


      const options = data.map((cls) => ({
        value: cls.classId,
        label: cls.className,
      }));


      setClassOptions(options);
      setLoadingBarProgress(100);


    } catch (error) {
      console.error("Error fetching class options:", error);
      setLoadingBarProgress(0);
    }
  };


  fetchClassOptions();


}, [selectedBranchId]);  // ✅ reload when branch changes


useEffect(() => {
  const fetchAnnouncementById = async () => {
    try {
      setIsLoading(true);


      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


     if (!id || !branchId) {
  setIsLoading(false);
  return;
}




      setLoadingBarProgress(30);


     const response = await fetch(
  `${apiUrl}/Anouncement/All_Anouncement_Admin?Branch_Id=${branchId}`,
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      noticeBoardId: id,
      branchId: branchId,
    }),
  }
);




      if (!response.ok) {
        throw new Error("Failed to fetch announcement");
      }


      
const result = await response.json();


const announcementList = result?.list || [];


const matchedAnnouncement = announcementList.find(
  (item) => String(item.noticeBoardId) === String(id)
);


if (!matchedAnnouncement) {
  setIsLoading(false);
  return;
}


setAnnouncementData(matchedAnnouncement);
setTitle(matchedAnnouncement.title || "");
setMessage(matchedAnnouncement.message || "");










      // ✅ Prefill title & message
     


      setLoadingBarProgress(100);
    } catch (error) {
      console.error("Error fetching announcement:", error);
      setLoadingBarProgress(0);
    } finally {
      setIsLoading(false);
    }
  };


const branchId =
  selectedBranchId || sessionStorage.getItem("branchId");


if (branchId) {
    fetchAnnouncementById();
}


}, [id, selectedBranchId]);






useEffect(() => {
  const fetchSectionOptions = async () => {
    if (!selectedClasses.length) {
      setSectionOptions([]);
      return;
    }


    const classId = selectedClasses[selectedClasses.length - 1].value;


    try {
      setLoadingBarProgress(30);


      const response = await fetch(
        "https://wsmsv1.aidigitalsec.com/api/Exam/ddlSection_clsId",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ classId }),
        }
      );


      const data = await response.json();


      const options = data.map((section) => ({
        value: section.sectionId,
        label: section.sectionName,
      }));


      setSectionOptions(options);


    // ✅ PREFILL SECTION (robust matching)
// ✅ PREFILL SECTION USING className
if (announcementData?.className && options.length) {
  const firstClass = announcementData.className
    .toString()
    .split(",")[0]
    .trim(); // e.g. "LKG-A1"


  const sectionPart = firstClass.split("-")[1]; // extract A1


  if (sectionPart) {
    const match = options.find(
      (s) =>
        s.label.toLowerCase().trim() ===
        sectionPart.toLowerCase().trim()
    );


    if (match) {
      setSelectedSection(match);
    }
  }
}












      setLoadingBarProgress(100);
    } catch (error) {
      console.error("Error fetching section options:", error);
      setLoadingBarProgress(0);
    }
  };


  fetchSectionOptions();
}, [selectedClasses, announcementData]);










const handleSave = async () => {
  if (
    !selectedBranchId ||
    selectedUsers.length === 0 ||
    selectedClasses.length === 0 ||
    !selectedSection ||
    title.trim() === "" ||
    message.trim() === ""
  ) {
    setError("Please fill in all required fields.");
    return;
  }


  const payload = {
  noticeBoardId: id,
  branchId: selectedBranchId,
  userGroupId: selectedUsers.map(u => u.value),
  classId: selectedClasses.map(c => c.value),
  sectionId: selectedSection.value,
  title: title.trim(),
  message: message.trim(),
};



  try {
    setLoadingBarProgress(30);


    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");


    const response = await fetch(
  `${apiUrl}/Anouncement/Id?Id=${id}&Branch_Id=${selectedBranchId}`,
  {
    method: "POST", // ✅ Use POST instead of PUT
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  }
);




    if (!response.ok) {
      throw new Error("Update failed");
    }


    setModalType("success");
    setModalMessage("Announcement Updated Successfully!");
    setModalOpen(true);
    setLoadingBarProgress(100);


  } catch (error) {
    console.error(error);
    setModalType("error");
    setModalMessage("Failed to update announcement");
    setModalOpen(true);
    setLoadingBarProgress(0);
  }
};




const handleCancel = () => {
  navigate(-1); // back to View page
};


const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");


    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });


    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};
useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);


  // Set the branchId from query parameter or sessionStorage
  const branchId = branchIdFromQuery || sessionStorage.getItem("branchId");
  setSelectedBranchId(branchId);


  if (isMasterUser) {
    fetchBranches();
  }
}, [branchIdFromQuery]);








useEffect(() => {
  if (!announcementData) return;
  if (!userOptions.length || !classOptions.length) return;


  // Prefill users
 if (announcementData?.createdFor) {
  const userNames = announcementData.createdFor
    .toString()
    .split(",")
    .map((name) => name.trim().toLowerCase());

  const matchedUsers = userOptions.filter((u) =>
    userNames.includes(u.label.toLowerCase())
  );

  setSelectedUsers(matchedUsers);
}



  // Prefill classes
  if (announcementData.className) {
    const classNames = announcementData.className
      .split(",")
      .map((name) => name.trim());


    const matchedClasses = classOptions.filter((c) =>
      classNames.some((name) =>
        name.includes(c.label)
      )
    );


    setSelectedClasses(matchedClasses);
  }
}, [announcementData, userOptions, classOptions]);


useEffect(() => {
  console.log("ANNOUNCEMENT DATA:", announcementData);
}, [announcementData]);


if (isLoading) {
  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography>Loading announcement details...</Typography>
      </Box>
    </Container>
  );
}






  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LoadingBar color="#0B1F3D" progress={loadingBarProgress} onLoaderFinished={() => setLoadingBarProgress(0)} />
     <AppBar position="static" sx={{ backgroundColor: "#0B1F3D" }}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>


    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
      Edit Announcement
    </Typography>


   
 <FormControl size="small" sx={{ width: 220 }}>
  <InputLabel sx={{ color: "white" }}>Branch</InputLabel>
  <MuiSelect
    value={selectedBranchId || ""}
    label="Branch"
    disabled
    startAdornment={
      <InputAdornment position="start">
        <LocationOnIcon sx={{ fontSize: 16 }} />
      </InputAdornment>
    }
    sx={{
      color: "white",
      backgroundColor: "rgba(255,255,255,0.1)",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,0.3)",
      },
      "& .MuiSvgIcon-root": { color: "white" },
      "& .MuiSelect-select.Mui-disabled": {
        color: "white !important",
        WebkitTextFillColor: "white !important",
      },
    }}
  >
    {branches.map((branch) => (
      <MenuItem key={branch.branchId} value={branch.branchId}>
        {branch.branchName}
      </MenuItem>
    ))}
  </MuiSelect>
</FormControl>





  </Toolbar>
</AppBar>


      <Paper elevation={3} style={{ padding: 24, width: '100%', margin: 'auto', marginTop: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select User(s) *
          </Typography>
          <Select
            isMulti
            options={userOptions}
            value={selectedUsers}
            onChange={setSelectedUsers}
            placeholder="Select user(s)"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select Class(es) *
          </Typography>
          <Select
            isMulti
            options={classOptions}
            value={selectedClasses}
            onChange={setSelectedClasses}
            placeholder="Select class(es)"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select Section *
          </Typography>
          <Select
            options={sectionOptions}
            value={selectedSection}
            onChange={setSelectedSection}
            placeholder="Select section"
            isDisabled={selectedClasses.length === 0}
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Title *
          </Typography>
          <TextField
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter announcement title"
            variant="outlined"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Message *
          </Typography>
          <Box
            sx={{
              '& .ql-container': { minHeight: 200, borderRadius: 2 },
              '& .ql-toolbar': { borderRadius: '8px 8px 0 0' },
              '& .ql-editor': { minHeight: 180 },
            }}
          >
            <ReactQuill
              value={message}
              onChange={setMessage}
              placeholder="Enter announcement message..."
              theme="snow"
            />
          </Box>
        </Box>
        {error && (
          <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 3 }}>
          <Tooltip
            title={
              !selectedUsers.length
                ? "Select User(s)"
                : !selectedClasses.length
                ? "Select Class(es)"
                : !selectedSection
                ? "Select Section"
                : !title.trim()
                ? "Enter Title"
                : !message.trim()
                ? "Enter Message"
                : ""
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ minWidth: 220 }}
              disabled={
  !selectedBranchId ||
  !selectedUsers.length ||
  !selectedClasses.length ||
  !selectedSection ||
  !title.trim() ||
  !message.trim()
}


              >
                Save Announcement
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
            sx={{ minWidth: 220 }}
          >
            Cancel
          </Button>
        </Box>
      </Paper>


      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f',
              padding: '12px 16px',
            }}
          >
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {setModalOpen(false); navigate(-1)}}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};


export default EditAnnouncement;


